import dynamic from 'next/dynamic'

export const DynamicTradeInDeviceSkeleton = dynamic(() =>
	import('./TradeInDeviceSkeleton').then(({ TradeInDeviceSkeleton }) => TradeInDeviceSkeleton)
)
